import type { Translate } from 'next-translate';
import React from 'react';
import { Container } from '@/components/elements/Container';
import { MyImage } from '@/components/elements/MyImage';
import { VideoPreview } from '@/components/elements/VideoPreview';
import { Button } from '@/components/UI/Button';
import { GenerateLandingLinkService, GoogleService } from '@/services';
import { type HeroWithVideo } from '@/types';
import { GOOGLE_EVENTS } from '@/constants';
import bgMobile from '@/public/images/landing/backgrounds/bg-abstract-mobile.webp';
import bg from '@/public/images/landing/backgrounds/bg-abstract.webp';
import styles from './HeroVideo.module.scss';

interface Props {
	data: HeroWithVideo;
	t: Translate;
	funnelLinkService?: string;
}
export const HeroVideo: React.FC<Props> = ({ data, t, funnelLinkService }) => {
	// Destructuring
	const { title, description, video, images, background } = data;

	const handleClick = () => {
		goToWebProduct();
	};

	const goToWebProduct = () => {
		GoogleService.logEvent(GOOGLE_EVENTS.LANDING_PASSED);
		window.location.href =
			funnelLinkService || GenerateLandingLinkService.webApp();
	};

	return (
		<section className={`${styles['hero']}`}>
			{background && (
				<MyImage
					imageProps={{
						src: bgMobile,
						alt: 'background image',
						title: `${t(title)}`,
						priority: true,
						fetchPriority: 'low',
					}}
					settings={{
						classes: {
							picture: `${styles['hero__background']}`,
							image: styles['hero__background-img'],
						},
					}}
				>
					<source srcSet={bg.src} media='(min-width: 1023px)' />
				</MyImage>
			)}
			<Container className={`${styles['hero__container']}`}>
				<div className={`${styles['hero__info']}`}>
					<h1 className={`${styles['hero__title']}`}>{t(title)}</h1>
					<p className={`${styles['hero__subtitle']}`}>{t(description)}</p>
				</div>

				<div className={`${styles['hero__button-wrapper']}`}>
					<Button
						as='button'
						preset='landing'
						text={t(data.buttonText)}
						size='large'
						classes={{
							button: styles['hero__button'],
						}}
						onClick={handleClick}
					/>
				</div>

				<div className={styles['hero__video-wrapper']}>
					<VideoPreview {...video} />
				</div>
			</Container>
		</section>
	);
};
